/* Restore only the Amazon A+ carousel groups verified in pond-aplus-carousel-source.json. */
(() => {
  'use strict';
  if (window.ACTICLEAR_APLUS_CAROUSEL) return;
  const reviewedGroups = {"compact":{"49913176064246":[{"id":"compact-aplus-clarity","imageIds":["compact-aplus-03","compact-aplus-04"]}],"49913176097014":[{"id":"compact-aplus-clarity","imageIds":["compact-aplus-03","compact-aplus-04"]}],"49913176129782":[{"id":"compact-aplus-clarity","imageIds":["compact-aplus-03","compact-aplus-04"]}],"50113861353718":[{"id":"compact-aplus-clarity","imageIds":["compact-aplus-03","compact-aplus-04"]}]},"large":{"49913279021302":[{"id":"large-aplus-clarity","imageIds":["large-aplus-03","large-aplus-04"]}],"49913279054070":[{"id":"large-aplus-clarity","imageIds":["large-aplus-03","large-aplus-04"]}]}};
  const selector = '.ac21-aplus-carousel';
  const states = new WeakMap();
  const mounted = new Set();
  let sequence = 0;
  let resizeObserver;
  let resizeFrame = 0;
  const esc = value => String(value ?? '').replace(/[&<>"']/g, character => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[character]));

  function imageLink(image, index) {
    const width = Number(image.width), height = Number(image.height);
    const size = Number.isInteger(width) && width > 0 && Number.isInteger(height) && height > 0 ? ` width="${width}" height="${height}"` : '';
    return `<a href="${esc(image.src)}" target="_blank" rel="noopener noreferrer" aria-label="Open product detail image ${index + 1} in full size"><img src="${esc(image.src)}" alt="${esc(image.alt || 'Product information image ' + (index + 1))}" loading="lazy" decoding="async"${size}></a>`;
  }

  function groupHTML(group, images, start) {
    const trackId = `ac21-aplus-track-${++sequence}`;
    const slides = group.imageIds.map((id, index) => `<div class="ac21-aplus-slide" role="group" aria-roledescription="slide" aria-label="${index + 1} of ${group.imageIds.length}">${imageLink(images[start + index], start + index)}</div>`).join('');
    const dots = group.imageIds.map((id, index) => `<button class="ac21-aplus-dot" type="button" data-aplus-index="${index}" aria-label="Go to slide ${index + 1} of ${group.imageIds.length}" aria-controls="${trackId}" aria-current="${index === 0 ? 'true' : 'false'}"><span aria-hidden="true"></span></button>`).join('');
    const arrow = direction => `<button class="ac21-aplus-arrow ac21-aplus-${direction === -1 ? 'previous' : 'next'}" type="button" data-aplus-step="${direction}" aria-label="${direction === -1 ? 'Previous' : 'Next'} slide" aria-controls="${trackId}"><svg aria-hidden="true" focusable="false" viewBox="0 0 24 24"><path d="${direction === -1 ? 'M15 5 8 12l7 7' : 'm9 5 7 7-7 7'}"></path></svg></button>`;
    return `<section class="ac21-aplus-carousel" data-aplus-group="${esc(group.id)}" role="region" aria-roledescription="carousel" aria-label="Product information images"><div class="ac21-aplus-track" id="${trackId}" tabindex="0" aria-label="Product information slides">${slides}</div><div class="ac21-aplus-controls">${arrow(-1)}${arrow(1)}<div class="ac21-aplus-dots">${dots}</div></div><p class="ac21-aplus-status" aria-live="polite" aria-atomic="true">Slide 1 of ${group.imageIds.length}</p></section>`;
  }

  function render({ productId, variantId, images } = {}) {
    const groups = reviewedGroups[String(productId)]?.[String(variantId)];
    if (!groups?.length || !Array.isArray(images) || !images.length) return null;
    const ids = images.map(image => String(image.id));
    if (new Set(ids).size !== ids.length || images.some(image => !image.src)) return null;
    const starts = new Map();
    const claimed = new Set();
    for (const group of groups) {
      const start = ids.indexOf(group.imageIds[0]);
      if (start < 0 || group.imageIds.length < 2 || group.imageIds.some((id, offset) => ids[start + offset] !== id || claimed.has(start + offset))) return null;
      group.imageIds.forEach((id, offset) => claimed.add(start + offset));
      starts.set(start, group);
    }
    const blocks = [];
    for (let index = 0; index < images.length;) {
      const group = starts.get(index);
      if (group) {
        blocks.push(groupHTML(group, images, index));
        index += group.imageIds.length;
      } else blocks.push(imageLink(images[index], index++));
    }
    return `<div class="amazon-details-images">${blocks.join('')}</div>`;
  }

  function update(state, index, announce = true) {
    state.index = Math.max(0, Math.min(state.slides.length - 1, index));
    const focusWillBeHidden = state.slides.some((slide, position) => position !== state.index && slide.contains(document.activeElement));
    state.dots.forEach((dot, position) => dot.setAttribute('aria-current', String(position === state.index)));
    state.slides.forEach((slide, position) => {
      const active = position === state.index;
      slide.setAttribute('aria-hidden', String(!active));
      slide.querySelector('a').tabIndex = active ? 0 : -1;
    });
    if (focusWillBeHidden) state.track.focus({ preventScroll: true });
    if (announce && state.status) state.status.textContent = `Slide ${state.index + 1} of ${state.slides.length}`;
  }

  function scrollToIndex(state, index, smooth = true) {
    const next = (index % state.slides.length + state.slides.length) % state.slides.length;
    update(state, next);
    const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    state.track.scrollTo({ left: next * state.track.clientWidth, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
  }

  function reconcileSize(state) {
    const width = state.track.clientWidth;
    if (!width || width === state.width) return;
    state.width = width;
    state.track.scrollTo({ left: state.index * width, behavior: 'auto' });
  }

  function ensure(root) {
    if (states.has(root)) return states.get(root);
    const track = root.querySelector('.ac21-aplus-track');
    if (!track) return null;
    const slides = [...track.querySelectorAll('.ac21-aplus-slide')];
    if (slides.length < 2) return null;
    const state = { root, track, slides, dots:[...root.querySelectorAll('[data-aplus-index]')], status:root.querySelector('.ac21-aplus-status'), index:0, width:track.clientWidth, timer:0 };
    states.set(root, state);
    mounted.add(state);
    update(state, 0, false);
    if (window.ResizeObserver) {
      resizeObserver ||= new ResizeObserver(entries => entries.forEach(entry => {
        const current = states.get(entry.target.closest(selector));
        if (current) reconcileSize(current);
      }));
      resizeObserver.observe(track);
    }
    return state;
  }

  function mount(host = document) {
    for (const state of mounted) {
      if (!state.root.isConnected) {
        clearTimeout(state.timer);
        resizeObserver?.unobserve(state.track);
        mounted.delete(state);
      }
    }
    if (host.matches?.(selector)) ensure(host);
    host.querySelectorAll(selector).forEach(ensure);
  }

  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-aplus-step],[data-aplus-index]');
    const root = button?.closest(selector);
    if (!root) return;
    const state = ensure(root);
    if (!state) return;
    event.preventDefault();
    if (button.hasAttribute('data-aplus-index')) scrollToIndex(state, Number(button.dataset.aplusIndex));
    else scrollToIndex(state, state.index + Number(button.dataset.aplusStep));
  });

  document.addEventListener('keydown', event => {
    if (event.altKey || event.ctrlKey || event.metaKey || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    const root = event.target.closest?.(selector);
    if (!root) return;
    const state = ensure(root);
    if (!state) return;
    event.preventDefault();
    const index = event.key === 'Home' ? 0 : event.key === 'End' ? state.slides.length - 1 : state.index + (event.key === 'ArrowRight' ? 1 : -1);
    scrollToIndex(state, index);
  });

  document.addEventListener('scroll', event => {
    if (!event.target.matches?.('.ac21-aplus-track')) return;
    const state = ensure(event.target.closest(selector));
    if (!state) return;
    clearTimeout(state.timer);
    state.timer = setTimeout(() => {
      if (!state.track.clientWidth || !state.root.isConnected) return;
      update(state, Math.round(state.track.scrollLeft / state.track.clientWidth));
    }, 120);
  }, true);

  window.addEventListener('resize', () => {
    cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(() => {
      mount();
      mounted.forEach(reconcileSize);
    });
  });
  window.ACTICLEAR_APLUS_CAROUSEL = { render, mount };
})();
